export default __webpack_public_path__ + "static/media/13.52cc1bbf.jpg";